import { getHttp } from '@/api/httpFactory';
import { API_URLS } from './urls';

const http = getHttp(import.meta.env.VITE_API_BASE_URL);

const surveysApi = {
    /**
     * Get a historic of all Surveys from the partner
     * @param {*} payload
     */
    async fetchSurveys() {
        const { data } = await http.get(API_URLS.SURVEYS.GET);

        return data;
    },

    /**
     * Submit a survey
     * @param {string} alias Survey alias
     * @param {Object} payload Survey responses
     */
    async submitSurvey(alias, payload) {
        await http.post(API_URLS.SURVEYS.POST(alias), { details: payload });
    },
};

export default surveysApi;
